import { CONTACT } from "@/data/content";

export const SITE = {
  name: "MARTIN NETTOYAGE",
  domain: "https://martinnettoyage.com",
  slogan: "Vite compris, vite restauré.",
};

const IMG = {
  autoExt: "https://static.prod-images.emergentagent.com/jobs/877c6a23-ea34-4c44-bcad-04f4869b2517/images/201abf98bfab9f2f3b8bd3f4de445c96b0d5fbfa4d80b1a064c7193612fe265d.png",
  interior: "https://static.prod-images.emergentagent.com/jobs/877c6a23-ea34-4c44-bcad-04f4869b2517/images/70ef1e3bf6fe0c98201120eaa3b1abbcc6be26d46ad99b07d44bbb6479b09b8d.png",
  detailing: "https://static.prod-images.emergentagent.com/jobs/877c6a23-ea34-4c44-bcad-04f4869b2517/images/df9ac35e4cf28b7a7b54e5fd9d142b5c6f6f88ac56c2759498809da3e9bd302a.png",
  fullcar: "https://static.prod-images.emergentagent.com/jobs/877c6a23-ea34-4c44-bcad-04f4869b2517/images/16cd78b73688a2d2dd599627c1569fcddd2f7cd6858c9ff7f5d6c35869ca0ddb.png",
  facade: "https://static.prod-images.emergentagent.com/jobs/877c6a23-ea34-4c44-bcad-04f4869b2517/images/77583dd025209bec19779a5f85823cef09829de16b4c51b5f737e3803f2a65ac.png",
  terrace: "https://static.prod-images.emergentagent.com/jobs/877c6a23-ea34-4c44-bcad-04f4869b2517/images/641e2ad2921cf40296f88cae6bb3503b18dc3f29ad00cd2944b99a49d8f42a79.png",
  allee: "https://static.prod-images.emergentagent.com/jobs/877c6a23-ea34-4c44-bcad-04f4869b2517/images/4a6bdf1d940c9552ae99dbdcabfe0b0cda90ab9eab5fe58c0bd1707546768592.png",
  solar: "https://static.prod-images.emergentagent.com/jobs/877c6a23-ea34-4c44-bcad-04f4869b2517/images/9a4aafe7bd54b86ac639af3ed3855246791e5e9f984ea09109da9e7b9acb6a26.png",
  garage: "https://static.prod-images.emergentagent.com/jobs/877c6a23-ea34-4c44-bcad-04f4869b2517/images/ae207f633bd70183e7c0847e36dc319554e3bb8844a99c25bb03d5ee2ca51135.png",
  house: "https://images.unsplash.com/photo-1748063578185-3d68121b11ff?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  endsite: "https://static.prod-images.emergentagent.com/jobs/877c6a23-ea34-4c44-bcad-04f4869b2517/images/f6fe8ca1200f630e318ce9f793cfb9d03821b4b095ee5a5601d060f426463259.png",
  fleet: "https://static.prod-images.emergentagent.com/jobs/877c6a23-ea34-4c44-bcad-04f4869b2517/images/c92ca5ca987d3eac3ff8a68eaa4332295544be018956116f8b0e61e15cb0a301.png",
  windows: "https://static.prod-images.emergentagent.com/jobs/877c6a23-ea34-4c44-bcad-04f4869b2517/images/3c9cdc1ac511b2ad87a1d82621a21dca0e3adbfba35ec8655b407af2e1f71f53.png",
  buildings: "https://static.prod-images.emergentagent.com/jobs/877c6a23-ea34-4c44-bcad-04f4869b2517/images/171992633488fbc6efa1b6bc08607f1deb72ccef91e85e6a804c7b1b34b3453a.png",
  retail: "https://static.prod-images.emergentagent.com/jobs/877c6a23-ea34-4c44-bcad-04f4869b2517/images/37cc3d82bdfd6e70284be6d0c68562450b49f26b6def3a87e6d6ca912e7d3402.png",
  warehouse: "https://static.prod-images.emergentagent.com/jobs/877c6a23-ea34-4c44-bcad-04f4869b2517/images/33e8081a4af2153705567056e14d314da451692315c8c70e2375cb7f5c589a7c.png",
};

const ZONE_TXT = "Belfort, Montbéliard et Héricourt";

export const CATEGORIES = [
  {
    slug: "auto-detailing",
    name: "Auto Detailing",
    service: "auto",
    image: IMG.autoExt,
    metaTitle: "Auto Detailing à Belfort, Montbéliard, Héricourt | MARTIN NETTOYAGE",
    metaDescription:
      "Detailing & pressing auto à Belfort, Montbéliard, Héricourt : injection-extraction, shampouinage sièges, polissage, céramique. Devis rapide, réservez en ligne.",
    intro:
      "Redonnez à votre véhicule son éclat d'origine grâce à notre detailing mobile. Pressing automobile de l'habitacle par injecteur-extracteur, shampouinage textile des sièges, détachage en profondeur et neutralisation d'odeurs, polissage de la carrosserie et protection céramique : un savoir-faire professionnel adapté à chaque surface.",
  },
  {
    slug: "nettoyage-habitat",
    name: "Nettoyage Habitat & Extérieurs",
    service: "habitat",
    image: IMG.facade,
    metaTitle: "Nettoyage extérieur habitat à Belfort & Montbéliard | MARTIN NETTOYAGE",
    metaDescription:
      "Nettoyage de façades, terrasses, allées, panneaux solaires et garages. Haute pression maîtrisée & vapeur. Belfort, Montbéliard, Héricourt.",
    intro:
      "Façades, terrasses, allées, toitures d'annexes ou panneaux solaires : nous restaurons et protégeons durablement les surfaces extérieures de votre habitat, sans les agresser.",
  },
  {
    slug: "entretien-preventif-neuf",
    name: "Immobilier neuf & Entretien préventif",
    service: "preventif",
    image: IMG.house,
    metaTitle: "Entretien préventif immobilier neuf | Nettoyage vapeur | MARTIN NETTOYAGE",
    metaDescription:
      "Nettoyage doux à la vapeur pour biens neufs et fin de chantier. Préservez la longévité de votre habitation. Belfort, Montbéliard, Héricourt.",
    intro:
      "Pour un bien récent, mieux vaut prévenir que restaurer. Nous mettons en place un entretien doux et régulier, à la vapeur, qui préserve les finitions neuves et la valeur de votre patrimoine.",
    noBooking: true,
  },
  {
    slug: "nettoyage-professionnel",
    name: "Nettoyage Professionnel",
    service: "pro",
    image: IMG.fleet,
    metaTitle: "Nettoyage professionnel entreprises à Belfort & Montbéliard | MARTIN NETTOYAGE",
    metaDescription:
      "Flottes, vitres en hauteur, immeubles, surfaces de vente, entrepôts et fin de chantier. Contrats sur-mesure pour pros. Belfort, Montbéliard, Héricourt.",
    intro:
      "Une offre dédiée aux entreprises, syndics et collectivités : devis sur-mesure, planning adapté à votre activité et facturation professionnelle, avec possibilité de contrats récurrents.",
    noBooking: true,
  },
];

export const SERVICES = [
  // AUTO
  {
    slug: "nettoyage-interieur-voiture",
    category: "auto-detailing",
    service: "auto",
    name: "Nettoyage intérieur de voiture",
    h1: "Nettoyage intérieur de voiture & pressing des sièges",
    image: IMG.interior,
    metaTitle: "Nettoyage intérieur voiture & sièges à Belfort, Montbéliard | MARTIN NETTOYAGE",
    metaDescription:
      "Pressing auto & shampouinage des sièges par injecteur-extracteur : détachage profond, odeurs neutralisées. Belfort, Montbéliard. Réservez en ligne.",
    intro:
      "Pressing automobile complet : aspiration profonde, shampouinage textile des sièges et moquettes par injecteur-extracteur (injection-extraction), détachage en profondeur, traitement anti-acariens et neutralisation d'odeurs. Votre habitacle retrouve fraîcheur et propreté comme au premier jour.",
    benefits: [
      "Aspiration profonde et détachage en profondeur des sièges et moquettes",
      "Shampouinage textile par injecteur-extracteur (injection-extraction)",
      "Traitement anti-acariens et désinfection vapeur",
      "Neutralisation d'odeurs, nettoyage et protection des plastiques et cuirs",
    ],
    faq: [
      { q: "Combien de temps dure un nettoyage intérieur complet ?", a: "Comptez en général 2 à 4 heures selon l'état et la taille du véhicule." },
      { q: "Traitez-vous les taches tenaces et les odeurs ?", a: "Oui, injection-extraction et traitement vapeur permettent d'éliminer la plupart des taches et odeurs." },
    ],
  },
  {
    slug: "polissage-carrosserie",
    category: "auto-detailing",
    service: "auto",
    name: "Polissage de carrosserie",
    h1: "Polissage & correction de peinture",
    image: IMG.detailing,
    metaTitle: "Polissage carrosserie & correction peinture | MARTIN NETTOYAGE",
    metaDescription:
      "Polissage professionnel : suppression des micro-rayures et tourbillons, brillance profonde. Belfort, Montbéliard, Héricourt. Devis rapide.",
    intro:
      "Le polissage corrige les micro-rayures, tourbillons et oxydations pour révéler une brillance profonde et homogène sur votre carrosserie.",
    benefits: [
      "Suppression des micro-rayures et tourbillons (swirls)",
      "Correction de l'oxydation et des traces d'eau",
      "Brillance miroir durable",
      "Préparation idéale avant protection céramique",
    ],
    faq: [
      { q: "Le polissage abîme-t-il le vernis ?", a: "Non, réalisé par un professionnel avec le bon abrasif, il retire une infime couche de vernis en toute sécurité." },
      { q: "Faut-il ensuite une protection ?", a: "Oui, une protection céramique ou cire prolonge le résultat et protège la peinture." },
    ],
  },
  {
    slug: "protection-ceramique",
    category: "auto-detailing",
    service: "auto",
    name: "Protection céramique",
    h1: "Protection céramique longue durée",
    image: IMG.detailing,
    metaTitle: "Protection céramique voiture Belfort, Montbéliard | MARTIN NETTOYAGE",
    metaDescription:
      "Traitement céramique professionnel : brillance intense, effet déperlant et protection durable de la peinture. Belfort, Montbéliard, Héricourt.",
    intro:
      "La protection céramique crée une couche protectrice ultra-résistante : brillance intense, effet déperlant et entretien facilité pendant plusieurs années.",
    benefits: [
      "Protection durable contre UV, pluie et salissures",
      "Effet hydrophobe : l'eau et la saleté glissent",
      "Brillance intense et profonde",
      "Lavages moins fréquents et plus faciles",
    ],
    faq: [
      { q: "Combien de temps dure une protection céramique ?", a: "Selon le produit et l'entretien, de 2 à 5 ans." },
      { q: "Un entretien est-il nécessaire ?", a: "Un lavage doux régulier suffit ; nous proposons un contrat d'entretien pour préserver le traitement." },
    ],
  },
  {
    slug: "lavage-exterieur-complet",
    category: "auto-detailing",
    service: "auto",
    name: "Lavage extérieur complet",
    h1: "Lavage extérieur complet",
    image: IMG.fullcar,
    metaTitle: "Lavage auto extérieur complet Belfort, Montbéliard | MARTIN NETTOYAGE",
    metaDescription:
      "Lavage extérieur soigné : carrosserie, jantes, vitres et plastiques. Résultat impeccable, sans traces. Belfort, Montbéliard, Héricourt.",
    intro:
      "Un lavage extérieur méticuleux à la main : carrosserie, jantes, passages de roue, vitres et plastiques retrouvent leur éclat, sans traces ni micro-rayures.",
    benefits: [
      "Lavage manuel doux sans micro-rayures",
      "Décontamination et nettoyage des jantes",
      "Vitres sans traces et plastiques ravivés",
      "Finition brillante et déperlante",
    ],
    faq: [
      { q: "Lavez-vous après une sortie boueuse ou hivernale ?", a: "Oui, nous retirons boue, sel et salissures en préservant la carrosserie." },
      { q: "Intervenez-vous à domicile ?", a: "Selon la prestation et le lieu ; précisez-le dans votre demande de devis." },
    ],
  },
  {
    slug: "retour-location-lld-loa",
    category: "auto-detailing",
    service: "urgence",
    name: "Retour de location LLD / LOA",
    h1: "Nettoyage retour de location (LLD / LOA)",
    image: IMG.autoExt,
    metaTitle: "Nettoyage retour location LLD LOA | Éviter les frais | MARTIN NETTOYAGE",
    metaDescription:
      "Remise en état avant restitution LLD/LOA pour éviter les frais de remise en état. Intervention rapide. Belfort, Montbéliard, Héricourt.",
    intro:
      "Avant de restituer votre véhicule en fin de LLD ou LOA, une remise en état complète (intérieur + extérieur) vous aide à éviter les frais de restitution souvent facturés par les loueurs.",
    benefits: [
      "Remise en état intérieure et extérieure complète",
      "Objectif : éviter les frais de restitution",
      "Intervention rapide avant la date de retour",
      "Idéal aussi pour la revente du véhicule",
    ],
    faq: [
      { q: "Quand dois-je réserver avant la restitution ?", a: "Idéalement quelques jours avant ; en urgence, nous proposons un devis sous 24h." },
      { q: "Cela garantit-il d'éviter les frais ?", a: "Un véhicule propre limite fortement les frais liés à l'état de propreté ; l'usure mécanique reste distincte." },
    ],
  },
  // HABITAT
  {
    slug: "nettoyage-facade",
    category: "nettoyage-habitat",
    service: "habitat",
    name: "Nettoyage de façade",
    h1: "Nettoyage de façade",
    image: IMG.facade,
    metaTitle: "Nettoyage de façade Belfort, Montbéliard, Héricourt | MARTIN NETTOYAGE",
    metaDescription:
      "Nettoyage et démoussage de façades : suppression des traces noires, algues et pollution. Ravalement doux. Belfort, Montbéliard, Héricourt.",
    intro:
      "Nous éliminons traces noires, algues et pollution incrustées sur vos façades avec des méthodes maîtrisées (basse/haute pression, produits adaptés) pour un mur comme neuf.",
    benefits: [
      "Suppression des traces noires, algues et lichens",
      "Traitement anti-mousse préventif",
      "Techniques adaptées à chaque revêtement",
      "Résultat durable, façade assainie",
    ],
    faq: [
      { q: "Le nettoyage abîme-t-il l'enduit ?", a: "Non, nous adaptons la pression et les produits au type de façade pour préserver le support." },
      { q: "À quelle fréquence nettoyer une façade ?", a: "En général tous les 3 à 5 ans, selon l'exposition et l'environnement." },
    ],
  },
  {
    slug: "nettoyage-terrasse-bois-pierre",
    category: "nettoyage-habitat",
    service: "habitat",
    name: "Nettoyage de terrasse (bois / pierre)",
    h1: "Nettoyage & restauration de terrasse",
    image: IMG.terrace,
    metaTitle: "Nettoyage terrasse bois & pierre Belfort, Montbéliard | MARTIN NETTOYAGE",
    metaDescription:
      "Restauration de terrasses bois, composite et pierre : démoussage, nettoyage en profondeur, protection. Belfort, Montbéliard, Héricourt.",
    intro:
      "Bois, composite, pierre ou carrelage : nous nettoyons en profondeur votre terrasse pour lui rendre sa couleur d'origine, puis la protégeons contre le grisaillement et les mousses.",
    benefits: [
      "Démoussage et nettoyage en profondeur",
      "Ravivage de la couleur du bois et de la pierre",
      "Traitement et protection anti-mousse",
      "Surfaces plus sûres, moins glissantes",
    ],
    faq: [
      { q: "Traitez-vous le bois après nettoyage ?", a: "Oui, nous pouvons appliquer un saturateur ou une protection adaptée en option." },
      { q: "À quelle fréquence entretenir une terrasse ?", a: "Un passage annuel ou trimestriel selon l'exposition ; un contrat d'entretien est possible." },
    ],
  },
  {
    slug: "nettoyage-allee-cour-paves",
    category: "nettoyage-habitat",
    service: "habitat",
    name: "Nettoyage d'allée, cour & pavés",
    h1: "Nettoyage d'allées, cours & pavés",
    image: IMG.allee,
    metaTitle: "Nettoyage allée, cour & pavés Belfort, Montbéliard | MARTIN NETTOYAGE",
    metaDescription:
      "Nettoyage haute pression d'allées, cours et pavés : suppression des mousses, taches et mauvaises herbes. Belfort, Montbéliard, Héricourt.",
    intro:
      "Allées, cours, pavés autobloquants ou dalles : nous retirons mousses, salissures et mauvaises herbes entre les joints pour des extérieurs nets et accueillants.",
    benefits: [
      "Suppression des mousses et taches incrustées",
      "Nettoyage des joints et retrait des herbes",
      "Surfaces désencrassées et sécurisées",
      "Option sablage des joints",
    ],
    faq: [
      { q: "Utilisez-vous des produits nocifs ?", a: "Nous privilégions des solutions respectueuses ; le traitement est adapté au type de sol." },
      { q: "Le pavé peut-il être re-sablé ?", a: "Oui, nous proposons le re-sablage des joints en option." },
    ],
  },
  {
    slug: "nettoyage-panneaux-solaires",
    category: "nettoyage-habitat",
    service: "habitat",
    name: "Nettoyage de panneaux solaires",
    h1: "Nettoyage de panneaux solaires",
    image: IMG.solar,
    metaTitle: "Nettoyage panneaux solaires Belfort, Montbéliard | Rendement maximisé",
    metaDescription:
      "Panneaux solaires encrassés = production perdue. Nettoyage à l'eau pure, sans rayure, pour récupérer votre rendement énergétique et rentabiliser votre installation.",
    intro:
      "Un panneau propre, c'est un panneau rentable. La poussière, les pollens et les fientes forment un film qui bloque la lumière et fait chuter votre production — donc vos revenus. Nous nettoyons vos panneaux photovoltaïques à l'eau pure osmosée, sans produit ni rayure, pour restaurer un rendement optimal et protéger votre investissement.",
    highlight:
      "ROI immédiat : des panneaux encrassés peuvent perdre de plusieurs % jusqu'à plus de 20 % de production dans les cas les plus sales. Chaque point de rendement récupéré, c'est de l'énergie autoconsommée ou revendue en plus — un nettoyage régulier se rembourse souvent tout seul sur votre facture.",
    benefits: [
      "Rendement énergétique restauré = économies et revenus de revente maximisés",
      "Amortissement de l'installation plus rapide",
      "Nettoyage à l'eau osmosée, sans traces ni film résiduel",
      "Sans produit abrasif ni rayure : garantie constructeur préservée",
      "Retrait des dépôts, pollens, poussières et fientes qui bloquent la lumière",
    ],
    faq: [
      { q: "À quelle fréquence nettoyer ses panneaux ?", a: "Une à deux fois par an selon l'environnement (arbres, poussières, oiseaux, proximité de routes ou champs). Un contrat d'entretien régulier garantit un rendement stable toute l'année." },
      { q: "Le nettoyage améliore-t-il vraiment la production ?", a: "Oui, nettement. Des panneaux encrassés perdent facilement plusieurs % de rendement, et bien plus en cas de dépôts importants (fientes, pollens, poussière agricole). Le gain de production couvre généralement le coût du nettoyage." },
      { q: "Le nettoyage est-il rentable ?", a: "Sur une installation qui produit toute l'année, récupérer ne serait-ce que quelques pourcents de rendement représente un gain concret sur votre facture et vos revenus de revente : c'est un investissement à retour rapide." },
    ],
  },
  {
    slug: "nettoyage-garage-annexes",
    category: "nettoyage-habitat",
    service: "habitat",
    name: "Nettoyage de garage & annexes",
    h1: "Nettoyage de garage & annexes",
    image: IMG.garage,
    metaTitle: "Nettoyage garage & annexes Belfort, Montbéliard | MARTIN NETTOYAGE",
    metaDescription:
      "Nettoyage de garages, caves, ateliers et annexes : dépoussiérage, dégraissage des sols, remise en état. Belfort, Montbéliard, Héricourt.",
    intro:
      "Garages, caves, ateliers ou dépendances : nous dépoussiérons, dégraissons les sols et remettons en état vos annexes pour des espaces sains et fonctionnels.",
    benefits: [
      "Dépoussiérage complet et toiles d'araignée",
      "Dégraissage et nettoyage des sols béton",
      "Retrait des traces d'huile et salissures",
      "Espaces assainis et rangés",
    ],
    faq: [
      { q: "Nettoyez-vous les taches d'huile au sol ?", a: "Oui, nous utilisons des dégraissants adaptés aux sols béton." },
      { q: "Videz-vous le garage avant ?", a: "Un espace dégagé facilite l'intervention ; nous en convenons ensemble au devis." },
    ],
  },
  // NEUF
  {
    slug: "nettoyage-vapeur",
    category: "entretien-preventif-neuf",
    service: "preventif",
    name: "Nettoyage à la vapeur",
    h1: "Nettoyage doux à la vapeur",
    image: IMG.house,
    metaTitle: "Nettoyage vapeur écologique Belfort, Montbéliard | MARTIN NETTOYAGE",
    metaDescription:
      "Nettoyage vapeur haute température, sans produits agressifs : idéal pour biens neufs et surfaces fragiles. Belfort, Montbéliard, Héricourt.",
    intro:
      "La vapeur haute température nettoie et assainit en profondeur, sans produits chimiques agressifs : une solution écologique idéale pour les surfaces neuves et fragiles.",
    benefits: [
      "Haute température, sans produits agressifs",
      "Écologique et sain pour la famille",
      "Respecte les finitions neuves",
      "Assainit et désinfecte les surfaces",
    ],
    faq: [
      { q: "La vapeur convient-elle à toutes les surfaces ?", a: "À la plupart des surfaces modernes ; nous adaptons la méthode au support." },
      { q: "Est-ce vraiment écologique ?", a: "Oui, la vapeur limite fortement l'usage de produits chimiques." },
    ],
  },
  {
    slug: "nettoyage-fin-de-chantier",
    category: "entretien-preventif-neuf",
    service: "pro",
    name: "Nettoyage de fin de chantier",
    h1: "Nettoyage de fin de chantier",
    image: IMG.endsite,
    metaTitle: "Nettoyage fin de chantier Belfort, Montbéliard | MARTIN NETTOYAGE",
    metaDescription:
      "Nettoyage après travaux et construction neuve : dépoussiérage, retrait des résidus, livraison impeccable. Belfort, Montbéliard, Héricourt.",
    intro:
      "Après travaux ou construction neuve, nous réalisons un nettoyage complet : dépoussiérage, retrait des résidus (plâtre, peinture, colle) et remise en état pour une livraison impeccable.",
    benefits: [
      "Dépoussiérage complet après travaux",
      "Retrait des résidus de plâtre, peinture et colle",
      "Nettoyage des vitres et sols neufs",
      "Livraison ou emménagement dans un bien propre",
    ],
    faq: [
      { q: "Intervenez-vous pour les particuliers et les pros ?", a: "Oui, aussi bien pour les propriétaires que pour les artisans et promoteurs." },
      { q: "Sous quel délai ?", a: "Selon l'ampleur du chantier ; nous établissons un planning au devis." },
    ],
  },
  // PROS
  {
    slug: "nettoyage-flotte-entreprise",
    category: "nettoyage-professionnel",
    service: "pro",
    name: "Nettoyage de flotte d'entreprise",
    h1: "Nettoyage de flotte d'entreprise",
    image: IMG.fleet,
    metaTitle: "Nettoyage flotte entreprise Belfort, Montbéliard | MARTIN NETTOYAGE",
    metaDescription:
      "Entretien de flottes de véhicules : utilitaires, VL, poids lourds. Image de marque impeccable, contrats récurrents. Belfort, Montbéliard, Héricourt.",
    intro:
      "Utilitaires, véhicules légers ou poids lourds : nous entretenons votre flotte pour une image de marque impeccable, avec des contrats récurrents adaptés à votre activité.",
    benefits: [
      "Entretien régulier de tous types de véhicules",
      "Image de marque soignée sur la route",
      "Planning et facturation professionnels",
      "Tarifs adaptés au volume",
    ],
    faq: [
      { q: "Intervenez-vous sur notre site ?", a: "Oui, selon la prestation nous pouvons intervenir sur votre parking d'entreprise." },
      { q: "Proposez-vous des contrats ?", a: "Oui, contrats mensuels ou trimestriels sur-mesure." },
    ],
  },
  {
    slug: "nettoyage-vitres-hauteur-sans-nacelle",
    category: "nettoyage-professionnel",
    service: "pro",
    name: "Nettoyage de vitres en hauteur",
    h1: "Nettoyage de vitres en hauteur (sans nacelle)",
    image: IMG.windows,
    metaTitle: "Nettoyage vitres en hauteur sans nacelle | MARTIN NETTOYAGE",
    metaDescription:
      "Vitres jusqu'à 3 étages sans nacelle grâce à la perche télescopique : plus économique et flexible. Belfort, Montbéliard, Héricourt.",
    intro:
      "Vitrines, baies et surfaces vitrées sans une trace, même en hauteur. Grâce à notre perche télescopique à eau pure, nous nettoyons jusqu'à 3 étages sans nacelle : plus économique et plus flexible.",
    benefits: [
      "Jusqu'à 3 étages sans nacelle",
      "Perche télescopique à eau pure, sans trace",
      "Plus économique et plus flexible",
      "Sécurité renforcée, intervention rapide",
    ],
    faq: [
      { q: "Pourquoi sans nacelle ?", a: "La perche à eau pure évite la location de nacelle : c'est plus rapide, plus sûr et moins coûteux." },
      { q: "Au-delà de 3 étages ?", a: "Nous étudions des solutions adaptées ; contactez-nous pour un devis." },
    ],
  },
  {
    slug: "nettoyage-immeubles-copropriete",
    category: "nettoyage-professionnel",
    service: "pro",
    name: "Nettoyage d'immeubles & copropriétés",
    h1: "Nettoyage d'immeubles & copropriétés",
    image: IMG.buildings,
    metaTitle: "Nettoyage immeubles & copropriétés Belfort, Montbéliard | MARTIN NETTOYAGE",
    metaDescription:
      "Entretien régulier des parties communes, cages d'escalier, façades et extérieurs pour syndics et copropriétés. Belfort, Montbéliard, Héricourt.",
    intro:
      "Parties communes, cages d'escalier, halls, façades et extérieurs : nous proposons aux syndics et copropriétés des contrats d'entretien réguliers pour un patrimoine valorisé.",
    benefits: [
      "Entretien régulier des parties communes",
      "Cages d'escalier, halls et vitrages",
      "Façades et extérieurs",
      "Contrats adaptés aux syndics",
    ],
    faq: [
      { q: "Travaillez-vous avec les syndics ?", a: "Oui, nous établissons des contrats cadres avec facturation professionnelle." },
      { q: "Quelle fréquence de passage ?", a: "Hebdomadaire, mensuelle ou trimestrielle selon vos besoins." },
    ],
  },
  {
    slug: "nettoyage-surface-de-vente",
    category: "nettoyage-professionnel",
    service: "pro",
    name: "Nettoyage de surface de vente",
    h1: "Nettoyage de surfaces de vente",
    image: IMG.retail,
    metaTitle: "Nettoyage surface de vente & magasin Belfort, Montbéliard | MARTIN NETTOYAGE",
    metaDescription:
      "Magasins, showrooms et commerces : sols, vitrines et espaces d'accueil impeccables pour valoriser votre point de vente. Belfort, Montbéliard, Héricourt.",
    intro:
      "Magasins, showrooms et commerces : nous entretenons vos sols, vitrines et espaces d'accueil pour offrir à vos clients un point de vente toujours impeccable.",
    benefits: [
      "Sols, vitrines et espaces d'accueil",
      "Intervention en dehors des heures d'ouverture",
      "Image soignée pour vos clients",
      "Contrats d'entretien réguliers",
    ],
    faq: [
      { q: "Intervenez-vous hors horaires d'ouverture ?", a: "Oui, pour ne pas gêner votre activité commerciale." },
      { q: "Gérez-vous plusieurs magasins ?", a: "Oui, contrats multi-sites possibles." },
    ],
  },
  {
    slug: "nettoyage-entrepot-logistique",
    category: "nettoyage-professionnel",
    service: "pro",
    name: "Nettoyage d'entrepôt & logistique",
    h1: "Nettoyage d'entrepôts & sites logistiques",
    image: IMG.warehouse,
    metaTitle: "Nettoyage entrepôt & logistique Belfort, Montbéliard | MARTIN NETTOYAGE",
    metaDescription:
      "Nettoyage de grandes surfaces industrielles : sols béton, zones de stockage et quais. Environnement de travail sain. Belfort, Montbéliard, Héricourt.",
    intro:
      "Grandes surfaces industrielles, zones de stockage et quais de chargement : nous dépoussiérons et nettoyons vos sols béton pour un environnement de travail sain et sûr.",
    benefits: [
      "Nettoyage de grands sols béton",
      "Zones de stockage et quais",
      "Dépoussiérage industriel",
      "Environnement de travail plus sûr",
    ],
    faq: [
      { q: "Nettoyez-vous les grandes surfaces ?", a: "Oui, nous disposons du matériel adapté aux surfaces industrielles." },
      { q: "Proposez-vous un entretien régulier ?", a: "Oui, avec un planning adapté à votre exploitation." },
    ],
  },
];

export const ZONES = [
  {
    slug: "nettoyage-belfort",
    city: "Belfort",
    image: IMG.house,
    metaTitle: "Nettoyage à Belfort — Auto, Habitat & Pro | MARTIN NETTOYAGE",
    metaDescription:
      "Detailing auto, nettoyage de façades, terrasses, vitres et professionnel à Belfort. Intervention rapide, devis sous 24/48h. MARTIN NETTOYAGE.",
    intro:
      "Basés à proximité, nous intervenons à Belfort et ses environs pour tous vos besoins de nettoyage technique : auto detailing, habitat, immobilier neuf et professionnels.",
  },
  {
    slug: "nettoyage-montbeliard",
    city: "Montbéliard",
    image: IMG.facade,
    metaTitle: "Nettoyage à Montbéliard — Auto, Habitat & Pro | MARTIN NETTOYAGE",
    metaDescription:
      "Detailing auto, façades, terrasses, vitres et nettoyage professionnel à Montbéliard. Intervention rapide, devis 24/48h. MARTIN NETTOYAGE.",
    intro:
      "À Montbéliard et dans le Pays de Montbéliard, MARTIN NETTOYAGE restaure et protège vos véhicules et votre habitat avec des techniques professionnelles.",
  },
  {
    slug: "nettoyage-hericourt",
    city: "Héricourt",
    image: IMG.terrace,
    metaTitle: "Nettoyage à Héricourt — Auto, Habitat & Pro | MARTIN NETTOYAGE",
    metaDescription:
      "Auto detailing, nettoyage de façades, terrasses, vitres et professionnel à Héricourt. Intervention rapide, devis 24/48h. MARTIN NETTOYAGE.",
    intro:
      "À Héricourt et alentours, nous proposons l'ensemble de nos prestations de nettoyage et de restauration de surfaces, pour les particuliers comme les professionnels.",
  },
];

export const findService = (slug) => SERVICES.find((s) => s.slug === slug);
export const findCategory = (slug) => CATEGORIES.find((c) => c.slug === slug);
export const findZone = (slug) => ZONES.find((z) => z.slug === slug);
export const servicesOfCategory = (catSlug) => SERVICES.filter((s) => s.category === catSlug);

export { CONTACT, ZONE_TXT };
